package blazern.lexisoup.privacy_policy

import androidx.compose.runtime.Composable

@Composable
fun PrivacyPolicyRoute() {
    PrivacyPolicyScreen()
}
